import { z } from 'zod';
/** Trims, enforces max length, and normalizes blank form strings to undefined (omit on create). */
export const optionalFormTrimmedString = (maxLength) => z
    .string()
    .trim()
    .max(maxLength)
    .transform((value) => (value === '' ? undefined : value))
    .optional();
/** Trims, enforces max length, and normalizes blank edit-form strings to null (explicit clear on update). */
export const optionalEditFormTrimmedString = (maxLength) => z
    .string()
    .trim()
    .max(maxLength)
    .transform((value) => (value === '' ? null : value))
    .optional()
    .nullable();
//# sourceMappingURL=optional-form-trimmed-string.js.map